import React, { useState } from "react";
import hotelplace from "../../assets/hotelplace.webp";
import { getHotelImage, getRoomTypeImage } from "../../assets/hotelImages";

const ImageWithFallback = ({
  src,
  hotelName,
  roomTypeName,
  alt,
  className,
  ...props
}) => {
  const [imgSrc, setImgSrc] = useState(src);
  const [fallbackIndex, setFallbackIndex] = useState(0);

  const roomFallback = roomTypeName ? getRoomTypeImage(hotelName, roomTypeName) : null;
  const hotelFallback = getHotelImage(hotelName);

  const fallbacks = [roomFallback, hotelFallback, hotelplace].filter(
    (f) => f && f !== src
  );

  const handleError = () => {
    if (fallbackIndex < fallbacks.length) {
      setImgSrc(fallbacks[fallbackIndex]);
      setFallbackIndex((prev) => prev + 1);
    }
  };

  return (
    <img
      src={imgSrc || hotelplace}
      alt={alt || ""}
      className={className}
      onError={handleError}
      {...props}
    />
  );
};

export default ImageWithFallback;
